module.exports = __webpack_public_path__ + "static/media/andrea.7d60d11a.jpg";